import {
	createContext
} from "react";
export const UserContext = createContext(null);
export const PriceContext = createContext(null);